import { Row, Col } from "../../../CommonComponents";
import "./OrderDetailView.scss";
import LeadrOrder from "./LeadrOrder";
import DriverDetail from "./DriverDetail";
import ApprovalHistoryTimeLineCommon from "client/CommonComponents/ApprovalHistoryTimeLineCommon";

const OrderDetailView = (props:any) => {  
  return (
      <Row>
        <Col xs={12} md={12} lg={8} className="customerorderUI">
          <LeadrOrder orderTypeId={props?.orderDetails.orderTypeId} ordersId={props?.orderDetails.orderId} isBulkOrder={props.isBulkOrder}/>
          <DriverDetail isBulkOrder={props.isBulkOrder}/>
        </Col>
        <Col xs={12} md={12} lg={4}>
          <ApprovalHistoryTimeLineCommon isOrderDetail = {true} approvalHistory = {props?.orderDetails?.approvalHistory} data-attribute="OrderDetailView_Default_ApprovalHistoryTimeLineCommon" />
        </Col>
      </Row>
  );
};

export default OrderDetailView;
